export default __webpack_public_path__ + "static/media/wh_ep1_tutorial_007.478d31ab.jpg";